import React from "react";
import classnames from "classnames";

export interface BadgeProps {
  style?: "primary" | "important" | "round";
  value: string;
  className?: string;
}

export const Badge = (props: BadgeProps) => {
  const style = props.style || "primary";
  const badgeClass = classnames(
    "inline-flex",
    style !== "round" ? "txt-body-mobile-10 tablet:txt-btn-sm" : "txt-body-mobile-10",
    style === "primary" ? "bg-off-white" : "bg-red",
    style === "primary" ? "text-ash" : "text-off-white",
    {
      "border border-input": style === "primary",
      "w-4 h-4 tablet:w-5 tablet:h-5 rounded-full items-center justify-center": style === "round",
      "px-1.5 py-0.5 tablet:px-2.5 tablet:py-2": style !== "round",
    },
    props.className
  );
  return <div className={badgeClass}>{props.value}</div>;
};
